import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import { clearState, setUdn} from "../../../redux/actions/generalActions/mainActions";
import { showLoader } from "../../../components/loader/loader";
import XtorageTagList from "./_list";
import SearchXt  from "../../../components/searchxt/searchXt";
import CardXt from "../../../components/cardsxt/cardXt";

const XtorageTag = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);

    return (
        <>
            { loading ? showLoader() : null}
            <h2 className="pb-2 font-bold ">Tags</h2>
            <SearchXt />
            <Row>
                <Col className="col-sm"><CardXt/></Col>
                <Col className="col-sm"><CardXt/></Col>
                <Col className="col-sm"><CardXt/></Col>
                <Col className="col-sm"><CardXt/></Col>
            </Row>
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <XtorageTagList />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
});

export default connect(mapStateToProps, mapActionsToProps)(XtorageTag)
